import styled from "@emotion/styled"

const TechThreeContent = styled.div`
  ${({ theme }) => theme.breakpoints.up("xl")} {
    grid-area: 2/2;
  }
`

export default TechThreeContent
